export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Список фондов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
